import { advanceSeed, normalizeSeed } from '@org/nonogram-engine';

export const MAX_TRAIN_SEED_LENGTH = 20;
export const TRAIN_SEED_VALIDATION_DELAY_MS = 300;

const SAFE_SEED_WORDS_A = [
  'amber',
  'apple',
  'beacon',
  'breeze',
  'cedar',
  'cloud',
  'cobalt',
  'comet',
  'copper',
  'dawn',
  'ember',
  'fern',
  'garden',
  'golden',
  'harbor',
  'hazel',
  'honey',
  'ivy',
  'maple',
  'meadow',
  'olive',
  'pebble',
  'quartz',
  'river',
  'spruce',
  'sunny',
  'velvet',
  'willow',
  'zephyr',
] as const;

const SAFE_SEED_WORDS_B = [
  'acorn',
  'anchor',
  'berry',
  'brook',
  'canyon',
  'clover',
  'coral',
  'dune',
  'field',
  'forest',
  'glade',
  'island',
  'lagoon',
  'market',
  'meadow',
  'moon',
  'reef',
  'ridge',
  'robin',
  'shore',
  'star',
  'summit',
  'trail',
  'valley',
  'wave',
  'wind',
] as const;

const SAFE_SEED_WORDS_C = [
  'atlas',
  'bloom',
  'bridge',
  'cabin',
  'candle',
  'circle',
  'cookie',
  'drift',
  'echo',
  'glow',
  'grove',
  'kindle',
  'marble',
  'north',
  'oasis',
  'pocket',
  'rocket',
  'song',
  'spark',
  'studio',
  'sunset',
  'ticket',
  'tulip',
  'vista',
  'window',
  'wonder',
  'yard',
] as const;

function pickWord(seed: number, words: readonly string[]): string {
  return words[seed % words.length];
}

function formatSeedWord(word: string): string {
  return `${word[0].toUpperCase()}${word.slice(1)}`;
}

function createSafeWordSeed(seed: number): string {
  const first = formatSeedWord(pickWord(seed, SAFE_SEED_WORDS_A));
  const second = formatSeedWord(
    pickWord(advanceSeed(seed, 1), SAFE_SEED_WORDS_B)
  );
  const third = formatSeedWord(
    pickWord(advanceSeed(seed, 2), SAFE_SEED_WORDS_C)
  );

  return `${first}-${second}-${third}`;
}

export function normalizeTrainSeedInput(seed: string): string {
  return seed.trim();
}

export function hasConfiguredTrainSeed(seed: string): boolean {
  return normalizeTrainSeedInput(seed).length > 0;
}

export function createTrainSeed(now = Date.now()): string {
  return createSafeWordSeed(normalizeSeed(now));
}

export function nextTrainSeed(seed: string, steps = 1): string {
  return createSafeWordSeed(advanceSeed(seed, steps));
}

export function formatTrainSeedLabel(
  seed: string,
  maxLength = MAX_TRAIN_SEED_LENGTH
): string {
  const normalized = normalizeTrainSeedInput(seed);

  if (!normalized) return 'seed';
  if (normalized.length <= maxLength) return normalized;

  return `${normalized.slice(0, Math.max(1, maxLength - 3))}...`;
}
